import css from '../../../utils/css';

export default css`
  :host,
  #root > div {
    --color-theme: var(--widget-background-color);
    --color-header-text: var(--widget-accent-text-color);

    --custom-font-family: var(--widget-font-family);
    --dimed-background-color: color-mix(
      in lch,
      var(--widget-background-color) 90%,
      var(--widget-text-color)
    );
    --dimed-accent-color: color-mix(
      in lch,
      var(--widget-accent-background-color) 95%,
      var(--widget-accent-text-color)
    );
    --muted-text-color: color-mix(
      in lch,
      var(--widget-text-color) 60%,
      transparent
    );

    --color-theme: var(--widget-text-color);
    --color-background: var(--widget-background-color);
    --color-text: var(--widget-text-color);

    /* spacing */
    [class*='_eventContainer_']:last-child {
      margin-bottom: 0;
    }
    [class*='ValueBetContainer_'] {
      margin-top: 0;
      background-color: transparent;
    }

    /* accented areas */
    [class*='_projectedIcon_'] {
      background-color: var(--widget-accent-text-color);
      color: var(--widget-accent-background-color);
    }
    [class*='_eventHeaderContainer_'] {
      background-color: var(--widget-accent-background-color);
    }
    [class*='_starsContainer_'] [class*='_starIcon_'] {
      &[data-active='false'] {
        fill: var(--dimed-background-color) !important;
      }
      &[data-active='true'] {
        fill: var(--widget-text-color) !important;
      }
    }

    /* cta */
    [class*='_bestBetContainer_'] {
      background-color: var(--widget-cta-background-color);

      & > a {
        gap: 0.25em;
        color: var(--widget-cta-color) !important;

        & > div:has(> img) {
          overflow: hidden;
          border-radius: var(--widget-cta-inner-border-radius, 0px);

          & > img {
            margin-right: 0 !important;
          }
        }
      }

      /* cta border radius */
      border-radius: var(--widget-cta-border-radius, 6px);
    }

    [class*='_eventContainer_'] {
      border-radius: var(--widget-border-radius, 6px);
    }

    /* move down background colour to save border radius */
    [class*='_valueBetMainContainer_'] {
      background: none !important;

      & > div {
        background: var(--color-background);
      }
    }

    /* backgrounds, text colours */
    [class*='_recommendedTeamContainer_'] tbody tr,
    [class*='_mobileRecommended_'] tbody tr,
    [class*='_playerTable_'] tbody tr td {
      background: transparent;
    }
    [class*='_eventExpandContainer_'],
    [class*='_recommendedTeamContainer_'] thead,
    [class*='_mobileRecommended_'] thead,
    [class*='_playerTable_'] thead {
      background-color: var(--dimed-background-color);
    }
    [class*='_playerPropLabel_'] {
      background-color: var(--dimed-accent-color);
      color: var(--widget-accent-text-color);
    }

    /* toggler icon */
    [class*='_eventExpandContainer_'] > div {
      border-color: currentColor;
      color: var(--widget-text-color);
    }
    [class*='_eventExpandContainer_']:hover > div {
      background: var(--widget-cta-background-color);
    }

    /* dividers */
    [class*='_playerTable_'] tbody td,
    [class*='_playerTable_'] thead tr,
    [class*='_recommendedTeamContainer_'],
    [class*='_recommendedTeamContainer_'] thead {
      border-color: var(--widget-divider-color);
    }

    /* team/player logo container */
    [class*='_playerImageContainer_'],
    [class*='_teamLogoContainer_'] {
      background-color: var(--dimed-background-color);
    }

    /* tooltip icon */
    [class*='_tooltip_'] svg {
      path {
        fill: var(--muted-text-color);
      }
      circle {
        stroke: var(--muted-text-color);
      }
    }
  }
`;
